<template>
  <div>

    <div class="card dashcard mb-0">
      <div class="card-body">
        <div class="form-row">
          <div class="col col-12 col-md-6">
            <az-periodo v-model="filtro" :sync="true" @sync="load()" />
          </div>
          <div class="col col-12 col-md-2">
            <az-input
              type="select"
              icon="fas fa-funnel-dollar"
              placeholder="Todos"
              optionsData="id"
              :optionsList="[{ id: 'A', search: 'Entregues'}, { id: 'E', search: 'Não Entregues'}]"
              v-model="filtro.lugar" />
          </div>
          <div class="col col-12 col-md-4">
            <az-input
              placeholder="Todas as Empresas..."
              icon="fas fa-store"
              type="autocomplete"
              optionsMode="aql"
              service="fornecedores.index"
              :optionsParm="{ ativas: true }"
              optionsData="id_fornecedor"
              optionsDisplay="search"
              v-model="filtro.id_fornecedor" />
          </div>
        </div>

        <div class="form-row mt-3">
          <div class="col col-12 col-md-4">
            <az-input
              icon="far fa-building fa-fw"
              type="select"
              placeholder="Todas"
              :optionsList="$util.unidades_com_tags(true, true)"
              optionsData="id_unidade_operacao"
              v-model="filtro.id_unidade_operacao" />
          </div>
          <div class="col col-12 col-md-8">
            <az-input
              icon="fa fa-search fa-fw" 
              v-model="filtro.search">
              <template v-slot:buttonposb>
                <print-export printid="lista-lancamentos" />
              </template>
            </az-input>
          </div>
        </div>
      </div>
    </div>

    <div class="progress mt-1 mb-3">
        <div class="indeterminate" v-if="$store.state.loading && dados"></div>
        <div class="determinate" v-else></div>
    </div>

    <div id="lista-lancamentos" v-if="dados && lista.length">

      <div class="d-none d-print-block mt-3">
        <h4>{{ $store.state.unidade.st_nome_fantasia }}</h4>
        <h3>Lançamentos</h3>
        <div class="alert alert-secondary">
          <div v-if="parametros">Período: ({{ parametros.tipo }}) {{ $util.getFormatDate(parametros.inicio) }} a {{ $util.getFormatDate(parametros.fim) }}</div>
        </div>
      </div>

      <table class="table table-hover table-responsive-md bg-white mt-3 small cabecalho-fixo">
        <thead>
          <tr>
            <th>Data</th>
            <th>Histórico</th>
            <th>Unidade</th>
            <th>Vencimento</th>
            <th>Categoria</th>
            <th class="text-right">Valor</th>
            <th class="text-center" v-if="lugar == 'E'">
              <button type="button" class="btn btn-outline-primary btn-sm d-print-none" @click="marcar_todos()">
                Todos
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(lanc, idx) in lista" :key="idx">
            <td :class="lanc.dt_vencimento < $util.hoje() ? 'text-danger' : ''">
                {{ $util.getFormatDate(lanc.dt_vencimento) }}
                <a href="#" @click.prevent="editar(lanc)" class="d-print-none">
                    #{{ lanc.id_lancamento }}
                </a>
            </td>
            <td>
              <i class="fas fa-exchange-alt" v-if="lanc.ch_tipo_lancamento == 'T' || lanc.ch_tipo_lancamento == 'M'"></i>
              <i class="fas fa-circle" :class="( lanc.ch_tipo_lancamento == 'D' ) ? 'text-danger' : 'text-success'" v-else-if="lanc.baixa"></i>
              <i class="far fa-dot-circle" :class="( lanc.ch_tipo_lancamento == 'D' ) ? 'text-danger' : 'text-success'" v-else></i>
              <template v-if="lanc.ch_tipo_lancamento == 'T' || lanc.ch_tipo_lancamento == 'M'">
                {{ lanc.conta_origem.search }} 
                <i class="fa fa-caret-right mx-1" aria-hidden="true"></i> 
                {{ lanc.conta_destino.search }}
                <span class="text-muted">({{ lanc.st_descricao }})</span>
              </template>
              <template v-else>
                {{ lanc.st_descricao }}
                <span v-if="lanc.st_doc" class="text-muted">
                  / {{ lanc.st_doc }}
                </span>
              </template>

              <a href="#" @click.prevent="carregar_recorrencia (lanc.id_recorrencia)">
                <i class="fas fa-sync-alt ml-2" v-if="lanc.id_recorrencia"></i>
                <span class="badge badge-secondary ml-1" v-if="lanc.in_parcela">
                  {{ lanc.in_parcela }}/{{ lanc.in_total_parcelas }}
                </span>
              </a>

              <a href="#" @click.prevent="abrir_anexar_arquivo(lanc)" class="ml-2 card-link">
                <i class="fa fa-plus" aria-hidden="true" v-if="!lanc.arquivos.length"></i>
                <div class="spinner-border spinner-border-sm" role="status" v-else-if="lanc.carregando">
                  <span class="sr-only">Loading...</span>
                </div>
                <i class="fa fa-paperclip" aria-hidden="true" v-else></i>
              </a>
              <div v-if="lanc.js_classes && lanc.js_classes.length > 0">
                <a href="#" @click.prevent="filtro.search == classe ? filtro.search = '' : filtro.search = classe" v-for="(classe, icx) in lanc.js_classes" :key="icx">
                  <span class="badge badge-success mr-1">
                    {{ classe }}
                  </span>
                </a>
              </div>
              <span v-if="lanc.item_pagamento_atendimento && lanc.item_pagamento_atendimento.pagamento_atendimento.id_atendimento"
                class="text-muted ml-2">
                #{{ lanc.item_pagamento_atendimento.pagamento_atendimento.id_atendimento }}
              </span>
            </td>
            <td>
              <span v-if="lanc.unidade_operacao">
                {{ lanc.unidade_operacao.st_sigla }}
              </span>
            </td>
            <td>
              {{ $util.getFormatDate(lanc.dt_vencimento) }}
            </td>
            <td>
              {{ lanc.categorias 
                ? lanc.categorias 
                : ( lanc.categoria ? lanc.categoria.st_categoria : ( lanc.ch_tipo_lancamento == 'T' ? 'Transferência' : ( lanc.ch_tipo_lancamento == 'M' ? 'Adiantamento' : '' ) ) ) }}
            </td>
            <td class="text-right">
              {{ $util.formatMoeda(lanc.dc_valor) }}
              <div>
                <small class="text-muted" v-if="lanc.dc_valor_uso_adiantamento > 0">
                  {{ $util.formatMoeda(lanc.dc_valor - lanc.dc_valor_uso_adiantamento) }}
                </small>
              </div>
            </td>
            <td class="text-center" v-if="lugar == 'E'">
              <input type="checkbox" v-if="!lanc.baixa" v-model="lanc.selecionado" /> 
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <th colspan="5">
              Total
            </th>
            <th class="text-right">
              {{ $util.formatMoeda(total_lancamentos) }}
              <div>
                <small class="text-muted" v-if="total_lancamentos != total_lancamentos_sem_adiant">
                  {{ $util.formatMoeda(total_lancamentos_sem_adiant) }}
                </small>
              </div>
            </th>
            <th v-if="lugar == 'E'"> 
            </th>
          </tr>
        </tfoot>
      </table>

    </div>

    <div class="mt-3" v-else>
      <az-empty-state msg="Nenhuma nota fiscal do suprimentos identificada." icon="fas fa-truck-loading" />
    </div>

    <!-- Modal -->
    <div class="modal fade" id="baixaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content" v-if="baixa">
          <div class="modal-header">
            <h5 class="modal-title">{{ baixa.id_baixa ? 'Baixa' : 'Registro de Baixa' }}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col col-12 col-md-4">
                <az-input
                  label="Data da Baixa"
                  type="date"
                  required 
                  v-model="baixa.dt_baixa" />
              </div>
              <div class="col col-12 col-md-4">
                <az-input
                    label="Forma de Pagamento"
                    :validate="validate"
                    type="select"
                    optionsMode="aql"
                    service="forma_pagamentos.index"
                    optionsData="id_forma_pagamento"
                    optionsDisplay="search"
                    required
                    v-model="baixa.id_forma_pagamento" />
              </div>
              <div class="col col-12 col-md-4">
                <az-input
                    label="Conta"
                    :validate="validate"
                    type="select"
                    optionsMode="aql"
                    service="contas.index"
                    optionsData="id_conta"
                    optionsDisplay="search"
                    required
                    v-model="baixa.id_conta" />
              </div>
            </div>

            <div class="row">
              <div class="col col-12 col-md-4">
                <az-input
                  label="Valor"
                  :validate="validate"
                  type="money"
                  v-model="baixa.dc_valor" />
              </div>
              <div class="col col-12 col-md-4">
                <az-input
                  icon="fa fa-plus-circle"
                  label="Multa/Juros"
                  :validate="validate"
                  type="money"
                  v-model="baixa.dc_multa_juros" />
              </div>
            </div>

            <div class="row">
              <div class="col col-12 col-md-4">
                <az-input
                  icon="fa fa-minus-circle"
                  label="Descontos/Taxas"
                  :validate="validate"
                  type="money"
                  v-model="baixa.dc_descontos" />
              </div>
              <div class="col col-12 col-md-4">
                <small class="form-text text-muted text-nowrap text-truncate">
                  Retenções
                </small>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="basic-addon1">
                      <i class="fa fa-minus-circle" aria-hidden="true"></i>
                    </span>
                  </div>
                  <label class="form form-control alert-secondary">
                    {{ $util.formatMoeda(baixa.dc_retencoes) }}
                  </label>
                </div>
              </div>
              <div class="col col-12 col-md-4">
                <small class="form-text text-muted text-nowrap text-truncate">
                  Valor Líquido
                </small>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="basic-addon1">
                      <i class="fas fa-equals"></i>
                    </span>
                  </div>
                  <label class="form form-control alert-secondary">
                    {{ $util.formatMoeda(baixa.dc_valor + baixa.dc_multa_juros - baixa.dc_descontos - baixa.dc_retencoes) }}
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col col-12">
                <az-input
                  label="Observação"
                  :validate="validate"
                  v-model="baixa.st_observacoes" />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <template v-if="solicitar_cancelar_baixa">
              <div class="input-group mb-0">
                <input type="text" class="form-control" placeholder="Informe o motivo de cancelamento..." v-model="baixa.st_motivo_cancelamento">
                <div class="input-group-append">
                  <button class="btn btn-secondary" type="button" @click="solicitar_cancelar_baixa = false">
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </button>
                  <button class="btn btn-danger" type="button" @click="cancelar_baixa ()">
                    <i class="fa fa-check" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </template>

            <template v-else>
              <az-audit-log-button model="baixa" :id="baixa.id_baixa" />
              <az-submit color="danger" @click="solicitar_cancelar_baixa = true" v-if="baixa.id_baixa && ( !baixa.fatura_creditos || !baixa.fatura_creditos.length )">Cancelar Baixa</az-submit>
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
              <az-submit @click="baixar ()">Atualizar</az-submit>
            </template>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="baixaMultiplaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content" v-if="baixa_multipla">
          <div class="modal-header">
            <h5 class="modal-title">Baixa Múltipla</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col col-12">
                <az-input
                  type="date"
                  label="Data"
                  :validate="validate"
                  required
                  v-model="baixa_multipla.dt_baixa" />
              </div>
            </div>
            <div class="row">
              <div class="col col-12">
                <az-input
                  label="Conta"
                  :validate="validate"
                  type="select"
                  optionsMode="aql"
                  service="contas.index"
                  optionsData="id_conta"
                  optionsDisplay="search"
                  required
                  v-model="baixa_multipla.id_conta" />
              </div>
            </div>
            <div class="row">
              <div class="col col-12">
                <az-input
                  label="Valor"
                  type="money"
                  :edicao="false"
                  required
                  v-model="baixa_multipla.dc_valor" />
              </div>
            </div>
            <div class="row">
              <div class="col col-12">
                <az-input
                  label="Retenções"
                  type="money"
                  :edicao="false"
                  required
                  v-model="baixa_multipla.dc_retencoes" />
              </div>
            </div>
            <div class="row">
              <div class="col col-12">
                <az-input
                  label="Líquido"
                  type="money"
                  :edicao="false"
                  required
                  v-model="baixa_multipla.liquido" />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
            <az-submit @click="baixar_multipla ()">Realizar</az-submit>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="cancelamentosModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Excluir Lançamentos</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <div class="lead">{{ selecionados.length }} {{ selecionados.length > 1 ? 'lançamentos' : 'lançamento' }}</div>
            <div class="lead">R$ {{ $util.formatMoeda (total_selecionado) }}</div>
            <div class="row" v-if="1 == 0">
              <div class="col col-12">
                <az-input
                  label="Motivo do Cancelamento"
                  required
                  v-model="motivo_cancelamentos" />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <az-submit color="danger" @click="confirmar_cancelar_lancamentos ()">Confirmar</az-submit>
          </div>
        </div>
      </div>
    </div>

    <nav class="navbar fixed-bottom navbar-light bg-light" v-if="lugar == 'E' && selecionados && selecionados.length > 0">
        <div class="navbar-brand">
          Total Selecionado: R$ {{ $util.formatMoeda (total_selecionado) }}
        </div>
        <div class='mr-3'> 
            <button class="btn btn-danger btn-sm ml-1" type="button" @click="cancelar_lancamentos ()">
                Excluir
            </button>
            <button class="btn btn-success btn-sm ml-1" type="button" @click="receber_notas ()">
                Receber
            </button>
        </div>
    </nav>

    <!-- Lançamento -->
    <edicao-lancamento ref="lancamento" :conta_ad="conta_ad" :unidade="filtro.id_unidade_operacao" @refresh="load()" />

    <!-- Envio de Arquivo -->
    <template v-if="acao_anexar && item">
      <az-file-upload
        ref="upload"
        @refresh="carregar_arquivos()"
        :multiple="true"
        :arquivos="item.arquivos"
        :parms="{ model_type: 'lancamento', model_id: item.id_lancamento }" />
    </template>

  </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import * as moment from "moment";
import AzSubmit from '../../util/AzSubmit.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import PrintExport from '../../shared/PrintExport.vue';
import EdicaoLancamento from './EdicaoLancamento.vue';
import AzFileUpload from '../../util/AzFileUpload.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';

export default {
  data() {
    return {
      dados: null, 
      parametros: null, 
      item: null, 
      validate: false,
      referencia: null, 
      from: "", 
      to: "",
      baixa: null, 
      baixa_multipla: null, 
      filtro: { 
        id_forma_pagamento: "",
        id_fornecedor: "", 
        search: "", 
        natureza: "", 
        status: "", 
        id_unidade_operacao: "", 
        periodo: "do",
        inicio: null,
        fim: null, 
        lugar: "E", 
      },
      solicitar_cancelar_baixa: false, 
      motivo_cancelamentos: "", 
      acao_anexar: false, 
      montando: true, 
      conta_ad: null, 
      lugar: null, 
    };
  },

  props: ['parms'],

  components: { 
    AzSubmit,
    AzInput, 
    AzEmptyState, 
    AzAuditLogButton, 
    PrintExport,
    EdicaoLancamento, 
    AzFileUpload,
    AzPeriodo, 
  },

  computed: { 
    dadosFormatados: function () { 

      return this.lista.map(lanc => { 
        return { 
          data: this.$util.getFormatDate(lanc.dt_vencimento),
          descricao: ( lanc.ch_tipo_lancamento == 'T' ? ( lanc.conta_origem.search + ' para ' + lanc.conta_destino.search ) : lanc.st_descricao ),
          competencia: this.$util.getFormatDate(lanc.dt_competencia, 'MM/YYYY'),
          categoria: lanc.categoria ? lanc.categoria.st_categoria : ( lanc.ch_tipo_lancamento == 'T' ? 'Transferência' : ( lanc.ch_tipo_lancamento == 'M' ? 'Adiantamento' : '' ) ),
          valor: this.$util.formatMoeda(lanc.dc_valor),
          fator: ( lanc.ch_tipo_lancamento == 'D' || lanc.ch_tipo_lancamento == 'M' ) ? -1 : ( lanc.ch_tipo_lancamento == 'T' ? 0 : 1 ), 
          baixado: lanc.baixa ? 'Sim' : 'Não',
          conta: lanc.baixa && lanc.baixa.conta ? lanc.baixa.conta.st_conta : '',
          liquido: lanc.baixa && lanc.baixa.conta ? this.$util.formatMoeda(lanc.baixa.valor_liquido) : '', 
          classificacao: lanc.js_classes,
        }
      });

    },

    lista: function () { 
      if ( !this.dados )
        return [];

      let pesquisar = this.filtro.search.trim();
      let parts = pesquisar.replace(' ','.*');
      let match = parts;
      let reg = new RegExp(match, 'i');

      return this.dados.filter(item => { 
        return ( !this.filtro.id_fornecedor || item.id_fornecedor == this.filtro.id_fornecedor ) && 
          ( !this.filtro.id_forma_pagamento || item.id_forma_pagamento == this.filtro.id_forma_pagamento ) && 
          ( !this.filtro.natureza || ( item.categoria && item.categoria.ch_natureza == this.filtro.natureza ) ) && 
          ( !this.filtro.status || this.filtrar_status (item, this.filtro.status) ) &&
          ( !this.filtro.search || reg.test(JSON.stringify(item)) );
      })
      .sort((a, b) => a.dt_vencimento > b.dt_vencimento ? 1 : -1 );
    },

    selecionados: function () { 
      let teste = _.uniqBy(this.lista.filter(item => item.selecionado), 'ch_tipo_lancamento').length;

      if ( teste > 1 )
        return [];

      return this.lista.filter(item => item.selecionado);
    },

    total_selecionado: function () { 
      return this.selecionados.reduce((total, item) => { 
        return total = total + item.dc_valor; 
      }, 0);
    },

    total_selecionado_retencoes: function () { 
      return this.selecionados.reduce((total, item) => { 
        return total = total + item.valor_retencoes; 
      }, 0);
    },

    total_lancamentos: function () { 
      return this.lista.reduce((total, item) => { 
        return total = total + item.dc_valor; 
      }, 0);
    },

    total_lancamentos_sem_adiant: function () { 
      return this.lista.reduce((total, item) => { 
        return total = total + item.dc_valor - item.dc_valor_uso_adiantamento; 
      }, 0);
    },

  },

  methods: { 
    receber_notas () { 
        if ( !confirm('Confirma receber os lançamentos selecioandos?') ) 
            return;

        this.$util.atualizar(this, { 
            service: 'financeiro',
            func: 'receber_suprimentos',
            dados: { 
                ids: this.selecionados.map(item => item.id_lancamento),
            },
            toast: true, 
            reload: true, 
        });
    },

    abrir_anexar_arquivo(item) { 
      this.item = item;

      if ( this.item.arquivos && this.item.arquivos.length && !this.item.arquivos.find(arq => arq.arquivo) ) { 
        this.item.carregando = true; 

        this.carregar_arquivos(true);

      } else { 

        this.acao_anexar = true;

        this.$nextTick(() => { 
          this.$refs.upload.abrir();
        });
        
      }

    },

    carregar_arquivos (abrir = false) { 

      this.$store.commit('loading', true);

      this.$util.loadItem(this, { 
        service: 'financeiro',
        func: 'show',
        parms: { 
          id: this.item.id_lancamento,
        },
      })
      .then(res => { 
        this.item.arquivos = res.arquivos;
        this.acao_anexar = true;

        if ( abrir ) { 
          this.$nextTick(() => { 
            this.$refs.upload.abrir();
          });
        }
      })
      .finally(() => { 
        this.item.carregando = false; 
        this.$store.commit('loading', false);
      });

    },

    marcar_todos() { 

      let tipo = "";
      let marcar = !( this.lista.findIndex(item => ( !item.baixa ) && item.selecionado) >= 0 ) ;

      this.lista.filter(item => !item.baixa)
      .forEach(element => {
        if ( !tipo )
          tipo = element.ch_tipo_lancamento;

        if ( tipo == element.ch_tipo_lancamento ) 
          element.selecionado = marcar;
      });

    },

    filtrar_status (item, status) { 
      if ( status == 'A' && item.baixa )
        return false;
      else if ( status == 'F' && !item.baixa )
        return false;
      else if ( status == 'T' && ( item.baixa || item.dt_vencimento >= this.$util.hoje () ) )
        return false;

      return true;
    },

    cancelar_lancamentos () { 
      this.motivo_cancelamentos = "";
      $('#cancelamentosModal').modal('show');
    },

    carregar_recorrencia (id) { 

      $('.modal').modal('hide');

      this.$util.load(this, { 
        service: 'financeiro',
        parms: { 
          id_recorrencia: id, 
        },
        loadTo: res => { 
          this.dados = res.lancamentos;
          this.conta_ad = res.adiantamento;
        }
      });

    },

    cancelar_baixa () { 

      this.$util.atualizar (this, { 
        service: 'financeiro',
        func: 'cancelar_baixa',
        dados: this.baixa,
        modal: 'baixaModal',
        reload: true, 
      });

    },

    confirmar_cancelar_lancamentos () { 

      this.$util.atualizar (this, { 
        service: 'financeiro',
        func: 'destroy',
        dados: { 
          lancamentos: this.selecionados.map(item => { return { id_lancamento: item.id_lancamento }; }),
        },
        modal: 'cancelamentosModal',
        reload: true, 
      });

    },

    calcular_taxa(lancamento) { 

      if ( !lancamento.bandeira_cartao )
        return 0;

      let taxa = ( lancamento.bandeira_cartao.por_unidade.dc_taxa / 100 );
      let parcelas = _.get(lancamento, 'item_pagamento_atendimento.in_parcelas');

      if ( parcelas > 1 && lancamento.bandeira_cartao.por_unidade.bandeira_cartao_parcelas ) { 
        
        let parcela = lancamento.bandeira_cartao.por_unidade.bandeira_cartao_parcelas.find(elem => { 
          return elem.in_parcela_min <= parcelas && ( !elem.in_parcela_max || elem.in_parcela_max >= parcelas );
        });

        if ( parcela ) { 
          taxa = ( parcela.dc_taxa / 100 );
        }

      }

      return lancamento.dc_valor * taxa;

    },

    registrar_baixa (item) { 
      $('.modal').modal('hide');

      this.baixa = null;
      this.validate = false;
      this.solicitar_cancelar_baixa = false;
      
      this.$nextTick(() => { 
  
        if ( item.baixa ) { 

          this.baixa = _.cloneDeep(item.baixa);

        } else { 

          let baixa = {
            id_baixa: null, 
            id_conta: "", 
            id_forma_pagamento: "", 
            id_lancamento: item.id_lancamento, 
            dt_baixa: this.$util.hoje(), 
            dc_valor: item.dc_valor,
            dc_multa_juros: 0,
            dc_descontos: 0, 
            fl_ativa: true, 
            st_observacoes: "", 
            st_motivo_cancelamento: "", 
            dc_retencoes: item.valor_retencoes,
          };

          if ( item.categoria && item.categoria.ch_natureza == 'C' && item.id_bandeira_cartao ) { 

            this.$util.loadItem(this, { 
              service: 'bandeira_cartaos',
              id: item.id_bandeira_cartao, 
            })
            .then(cartao => { 

              baixa.dc_descontos = baixa.dc_valor * ( cartao.por_unidade.dc_taxa / 100 );

              let parcelas = _.get(item, 'item_pagamento_atendimento.in_parcelas');
              
              if ( parcelas > 1 && cartao.por_unidade.bandeira_cartao_parcelas ) { 
                
                let parcela = cartao.por_unidade.bandeira_cartao_parcelas.find(elem => { 
                  return elem.in_parcela_min <= parcelas && ( !elem.in_parcela_max || elem.in_parcela_max >= parcelas );
                });

                if ( parcela ) { 
                  baixa.dc_descontos = baixa.dc_valor * ( parcela.dc_taxa / 100 );
                }

              }

              this.baixa = baixa;
              abrir();
            });

            return;

          } else { 

            this.baixa = baixa;

          }

        }

        abrir();

      });

      function abrir() { 
        $('#baixaModal').modal('show');
      }

    },

    incluir () { 
      this.$refs.lancamento.incluir ();
    },

    editar (item) { 
      this.$refs.lancamento.editar(item);
    },

    baixar () { 

      this.$util.atualizar (this, { 
        service: 'financeiro',
        func: 'baixar',
        dados: this.baixa,
        modal: 'baixaModal',
        reload: true, 
      });

    },

    baixar_multipla () { 

      this.$util.atualizar (this, { 
        service: 'financeiro',
        func: 'baixar_multipla',
        dados: { 
          ...this.baixa_multipla,
          lancamentos: this.selecionados 
        },
        modal: 'baixaMultiplaModal',
        reload: true, 
      });

    },

    atualizar () { 
      let dados = { ...this.item };
      dados.dt_competencia = dados.dt_competencia.substr (0,7);

      this.$util.atualizar (this, { 
        service: 'financeiro',
        dados: dados, 
        modal: 'lancamentoModal', 
        reload: true, 
      });
    },

    load () { 
      if ( this.montando )
        return;

      if ( this.referencia ) { 
        if ( !this.from || !this.to || this.from > this.to ) { 
          this.dados = null;
          return;
        }
      }

      this.$util.load(this, { 
        service: 'financeiro',
        parms: { 
          lista: true, 
          compet: true, 
          ...this.filtro, 
          suprimentos: true, 
        },
        loadTo: res => { 
          this.dados = res.lancamentos;
          this.parametros = res.parametros; 
          this.conta_ad = res.adiantamento;
          this.lugar = res.lugar;
        }
      });
    }
  },

  created () { 
    
    this.referencia = this.$util.hoje().substr(0,7);

    if ( this.parms ) { 

      if ( this.parms.mes == 'T' ) { 
        this.referencia = "";
      } else if ( this.parms.mes ) {
        this.filtro.periodo = "lm";
        this.filtro.mes = this.parms.mes;

        this.referencia = this.parms.mes;
      }

      if ( this.parms.natureza ) { 
        this.filtro.natureza = this.parms.natureza;
      }

      if ( this.parms.categoria ) { 
        this.filtro.search = this.parms.categoria;
      }

      if ( this.parms.status ) { 
        this.filtro.status = this.parms.status;
      }
    
    }

    if ( this.referencia ) { 
      this.from = this.referencia + '-01';
      this.to = moment(this.referencia + '-01').endOf('month').format('YYYY-MM-DD');
    }

  },

  mounted() {
    this.$store.commit("setBreadcrumb", [
      { name: "Financeiro", path: "/financeiro/visao" },
      { name: "Notas do Suprimentos", path: "/financeiro/notas-suprimentos" }
    ]);

    /*
    if ( this.$route.path != '/financeiro/lancamento' ) { 
      this.$router.push({ path: '/financeiro/lancamento' });
    }
    */

    this.$nextTick(() =>  { 
      this.montando = false;
      this.load();
    });
  },

  updated () { 
    $('[data-toggle="tooltip"]').tooltip();
  }
  
};
</script>